import type { ListType } from '@/models/app';

export const defaultHomeServiceGogoFee = 4;

export const providerSourceList: ListType[] = [
  { id: 1, key: 'TaskRabbit', label: 'TaskRabbit' },
  { id: 2, key: 'Thumbtack', label: 'Thumbtack' },
  { id: 3, key: 'Poplin', label: 'Poplin' },
  { id: 4, key: 'Care.com', label: 'Care.com' },
  { id: 5, key: 'Craiglist', label: 'Craiglist' },
  { id: 6, key: 'Other', label: 'Other' },
];

export const backgroundCheckSourcedList: ListType[] = [
  { id: 1, key: 'TaskRabbit', label: 'TaskRabbit' },
  { id: 2, key: 'Thumbtack', label: 'Thumbtack' },
  { id: 3, key: 'Poplin', label: 'Poplin' },
  { id: 4, key: 'Checkr', label: 'Checkr' },
];

export const paymentMethodList: ListType[] = [
  { id: 1, key: 'TaskRabbit', label: 'TaskRabbit' },
  { id: 2, key: 'Thumbtack', label: 'Thumbtack' },
  { id: 3, key: 'Poplin', label: 'Poplin' },
  { id: 4, key: 'Gusto', label: 'Gusto' },
  { id: 5, key: 'QuickBooks', label: 'QuickBooks' },
  { id: 6, key: 'PayPal Business', label: 'PayPal Business' },
  { id: 7, key: 'Stripe', label: 'Stripe' },
  { id: 8, key: 'Square', label: 'Square' },
  { id: 9, key: 'Other', label: 'Other' },
];

export const homeServiceOrderCancellationReasonList: ListType[] = [
  { id: 1, key: 'Cost', label: 'Cost' },
  { id: 2, key: 'Deactivating GoGo Membership', label: 'Deactivating GoGo Membership' },
  { id: 3, key: 'Found Another Provider', label: 'Found Another Provider' },
  { id: 4, key: 'No Longer Needed', label: 'No Longer Needed' },
  { id: 5, key: 'No Providers Available', label: 'No Providers Available' },
  { id: 6, key: 'Payment Method Not Accepted - Customer', label: 'Payment Method Not Accepted - Customer' },
  { id: 7, key: 'Provider Canceled – No Replacement', label: 'Provider Canceled – No Replacement' },
  { id: 8, key: 'Provider Payment Not Accepted - Provider', label: 'Provider Payment Not Accepted - Provider' },
  { id: 9, key: 'Scheduling / Timing', label: 'Scheduling / Timing' },
  { id: 10, key: 'Service Not Offered', label: 'Service Not Offered' },
  { id: 11, key: 'Unable to Contact', label: 'Unable to Contact' },
  { id: 12, key: 'Wants to Use Insurance', label: 'Wants to Use Insurance' },
  { id: 13, key: 'Other', label: 'Other' },
];

export const reasonForNeedingAdditionalNotes = ['Deactivating GoGo Membership', 'Other'];

export const homeServiceHearAboutUsList: ListType[] = [
  { id: 1, key: 'Google Search', label: 'Google Search' },
  { id: 2, key: 'Facebook / Instagram', label: 'Facebook / Instagram' },
  { id: 3, key: 'Website (Direct / Online)', label: 'Website (Direct / Online)' },
  { id: 4, key: 'Word of Mouth (Friend / Family)', label: 'Word of Mouth (Friend / Family)' },
  { id: 5, key: 'Referral (Professional / Organization)', label: 'Referral (Professional / Organization)' },
  { id: 6, key: 'Text Message (SMS)', label: 'Text Message (SMS)' },
  { id: 7, key: 'Email', label: 'Email' },
  { id: 8, key: 'Phone System', label: 'Phone System' },
  { id: 9, key: 'Phone Call / Inbound Inquiry', label: 'Phone Call / Inbound Inquiry' },
  { id: 10, key: 'Operator / GoGo Staff Referral', label: 'Operator / GoGo Staff Referral' },
  { id: 11, key: 'Marketing Lead (FB Leads / Paid Leads)', label: 'Marketing Lead (FB Leads / Paid Leads)' },
  { id: 12, key: 'Mail / Brochure / Printed Material', label: 'Mail / Brochure / Printed Material' },
  { id: 13, key: 'Other', label: 'Other' },
  { id: 14, key: 'Bing', label: 'Bing' },
];
